var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSixDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.007,
    height: 27.681,
    viewBox: "0 0 24.007 27.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sixDots",
    transform: "translate(-278.374 -158.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M285.374,160.769c0,1.45-1.567,2.627-3.5,2.627s-3.5-1.176-3.5-2.627,1.567-2.626,3.5-2.626,3.5,1.176,3.5,2.626",
    fill: "#2260ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M386.844,160.769c0,1.45-1.567,2.627-3.5,2.627s-3.5-1.176-3.5-2.627,1.567-2.626,3.5-2.626,3.5,1.176,3.5,2.626",
    transform: "translate(-84.463)",
    fill: "#2260ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M285.374,261.739c0,1.451-1.567,2.626-3.5,2.626s-3.5-1.176-3.5-2.626,1.567-2.626,3.5-2.626,3.5,1.176,3.5,2.626",
    transform: "translate(0 -89.755)",
    fill: "#2260ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M386.844,261.739c0,1.451-1.567,2.626-3.5,2.626s-3.5-1.176-3.5-2.626,1.567-2.626,3.5-2.626,3.5,1.176,3.5,2.626",
    transform: "translate(-84.463 -89.755)",
    fill: "#2260ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M285.374,362.706c0,1.451-1.567,2.626-3.5,2.626s-3.5-1.176-3.5-2.626,1.567-2.627,3.5-2.627,3.5,1.176,3.5,2.627",
    transform: "translate(0 -179.508)",
    fill: "#2260ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M386.844,362.706c0,1.451-1.567,2.626-3.5,2.626s-3.5-1.176-3.5-2.626,1.567-2.627,3.5-2.627,3.5,1.176,3.5,2.627",
    transform: "translate(-84.463 -179.508)",
    fill: "#2260ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixDots);
export default __webpack_public_path__ + "static/media/sixDots.72f7ea1291084291cc1aec2621837b79.svg";
export { ForwardRef as ReactComponent };